var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('img',{staticClass:"image",attrs:{"src":require("../../assets/images/triangle.png"),"alt":""}}),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }